var css = {"sliderContainer":"Slider-module_sliderContainer__wCttJ","gradient":"Slider-module_gradient__8MKHD","gradient-red-to-blue":"Slider-module_gradient-red-to-blue__PJkyY","gradient-red-to-green-to-red":"Slider-module_gradient-red-to-green-to-red__C2n66","thumbStripes":"Slider-module_thumbStripes__QCC6s"};

export { css as default };
